<div
  class="withdraw-root"
  *appHasPermission="[
    { resource: Resources.MerchantTransactions, scope: Scopes.Create },
    { resource: Resources.MerchantWallets, scope: Scopes.Read },
  ]"
>
  @if (viewState === 'initial') {
    <div class="withdraw-content">
      <app-merchant-withdraw-form
        [currentStep]="stepForm"
        [isSettlementApp]="isSettlementApp"
        [initialFormData]="initialFormData"
        [isMultiRiskPaymentsEnabled]="isMultiRiskPaymentsEnabled"
        [riskGroups]="riskGroups"
        [routingMode]="routingMode"
        [merchantId]="merchantId"
        [selectedSourceWallet]="selectedSourceWallet"
        [selectedDestinationWallet]="selectedDestinationWallet"
        [totalBalance]="totalBalance"
        (formSubmit)="proceedToWithdrawalType($event)"
        (currencyChanged)="onCurrencyFilterChanged($event.currency)"
        (blockchainChanged)="onBlockchainFilterChanged($event)"
        (routingModeChanged)="onRoutingModeChanged($event)"
      >
      </app-merchant-withdraw-form>
      @if (!isSettlementApp || routingMode === 'wallet') {
        <div class="wallet-selection-panel">
          <div class="panel-header">
            <h3>{{ isSettlementApp ? 'Select Source Wallet' : 'Select Destination Wallet' }}</h3>
            <app-pill-search
              [searchText]="searchText"
              placeholder="Search wallets"
              (searchChange)="onSearchChange($event)"
            ></app-pill-search>
          </div>
          <div class="wallet-grid">
            @if (isLoading) {
              <div class="loading-indicator">
                <app-loading-spinner size="large" label="Loading wallets..."></app-loading-spinner>
              </div>
            }

            @if (error) {
              <div class="error-message">
                {{ error }}
              </div>
            }

            @if (!isLoading && !error && activeWallets.length === 0 && searchText) {
              <div class="no-results">No wallets found matching "{{ searchText }}".</div>
            }

            @if (!isLoading && !error && activeWallets.length === 0 && !searchText) {
              <div class="no-results">
                {{ isSettlementApp ? 'No wallets available for this merchant.' : 'No destination wallets available.' }}
              </div>
            }

            <div class="wallets-list">
              <app-virtual-scroll [items]="activeWallets" size="wallet" [itemHeight]="walletCardHeight">
                <ng-template let-wallet>
                  <div
                    class="wallet-card-wrapper"
                    (click)="onWalletSelected(wallet)"
                    [class.selected]="isWalletSelected(wallet.id)"
                  >
                    <app-wallet-card
                      [id]="wallet.id"
                      [name]="wallet.walletName || 'Wallet ' + wallet.id.substring(0, 6)"
                      [address]="wallet.address"
                      [networkType]="wallet.networkType"
                      [currencies]="getWalletCurrencies(wallet)"
                      [risk]="getRiskLevelName(wallet.riskLevel)"
                      [pending]="wallet.status === WalletStatusEnum.Pending"
                      [showRiskLevel]="isSettlementApp"
                    >
                    </app-wallet-card>
                  </div>
                </ng-template>
              </app-virtual-scroll>
            </div>
          </div>
        </div>
      }
    </div>
  }

  @if (viewState === 'withdrawal-type') {
    <div class="withdraw-content">
      <app-merchant-withdraw-form
        [currentStep]="stepForm"
        [initialFormData]="initialFormData"
        [isSettlementApp]="isSettlementApp"
        [isMultiRiskPaymentsEnabled]="isMultiRiskPaymentsEnabled"
        [riskGroups]="riskGroups"
        [routingMode]="routingMode"
        [merchantId]="merchantId"
        [selectedDestinationWallet]="selectedDestinationWallet"
        [selectedSourceWallet]="selectedSourceWallet"
        [totalBalance]="totalBalance"
        [automaticAvailableBalance]="automaticAvailableBalance"
        (formSubmit)="proceedToSummary($event)"
        (withdrawalTypeChanged)="onWithdrawalTypeChanged($event)"
        (backClicked)="goBackToInitial()"
      >
      </app-merchant-withdraw-form>

      <div class="wallet-selection-panel">
        @if (isSettlementApp && routingMode === 'wallet') {
          <div class="sending-wallet-section">
            <div class="panel-header">
              <h3>Sending Wallet</h3>
            </div>
            <div class="wallet-grid">
              @if (selectedSourceWallet !== null) {
                <div class="wallet-card-wrapper" [class.selected]="isWalletSelected(selectedSourceWallet.id)">
                  <app-wallet-card
                    [id]="selectedSourceWallet.id"
                    [name]="selectedSourceWallet.walletName || 'Wallet ' + selectedSourceWallet.id.substring(0, 6)"
                    [address]="selectedSourceWallet.address"
                    [networkType]="selectedSourceWallet.networkType"
                    [currencies]="getWalletCurrencies(selectedSourceWallet)"
                    [risk]="getRiskLevelName(selectedSourceWallet.riskLevel)"
                    [pending]="selectedSourceWallet.status === WalletStatusEnum.Pending"
                    [showRiskLevel]="isSettlementApp"
                  >
                  </app-wallet-card>
                </div>
              }
            </div>
          </div>
        }

        <div class="wallet-selection-panel destination">
          <div class="panel-header">
            <h3>Select Destination Wallet</h3>
            @if (isSettlementApp) {
              <app-pill-search
                [searchText]="searchText"
                placeholder="Search wallets"
                (searchChange)="onSearchChange($event)"
                [isDisabled]="selectedWithdrawalType === null"
              ></app-pill-search>
            }
          </div>

          <div class="wallet-grid">
            @if (error) {
              <div class="error-message">
                {{ error }}
              </div>
            }

            @if (!isLoading && !error && payoutWallets.length === 0 && searchText) {
              <div class="no-results">No wallets found matching "{{ searchText }}".</div>
            }

            @if (
              !isLoading && !error && selectedWithdrawalType !== null && searchText === '' && payoutWallets.length === 0
            ) {
              <div class="no-results">No destination wallets available for this payout</div>
            }

            <div class="wallets-list">
              @if (selectedWithdrawalType !== null) {
                <app-virtual-scroll [items]="payoutWallets" size="wallet" [itemHeight]="walletCardHeight">
                  <ng-template let-wallet>
                    <div
                      class="wallet-card-wrapper"
                      (click)="onWalletSelected(wallet)"
                      [class.selected]="isWalletSelected(wallet.id)"
                    >
                      <app-wallet-card
                        [id]="wallet.id"
                        [name]="wallet.walletName || 'Wallet ' + wallet.id.substring(0, 6)"
                        [address]="wallet.address"
                        [networkType]="wallet.networkType"
                        [currencies]="getWalletCurrencies(wallet)"
                        [risk]="getRiskLevelName(wallet.riskLevel)"
                        [pending]="wallet.status === WalletStatusEnum.Pending"
                        [showRiskLevel]="isSettlementApp"
                      >
                      </app-wallet-card>
                    </div>
                  </ng-template>
                </app-virtual-scroll>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  @if (viewState === 'summary') {
    <div class="summary-layout" [class.with-tree]="showsSourcingTree">
      <div class="summary-layout-main">
        <app-summary-view
          [displayDetails]="displayDetails"
          [isSettlementApp]="isSettlementApp"
          [title]="'Withdrawal Summary'"
          (cancelled)="resetToInitialState()"
          (confirmed)="openOtp()"
        >
        </app-summary-view>
      </div>

      @if (showsSourcingTree) {
        <div class="summary-layout-tree">
          @if (isLoadingSourcing) {
            <div class="sourcing-loading">
              <app-loading-spinner size="large" label="Resolving sourcing wallets..."></app-loading-spinner>
            </div>
          } @else if (hasSourcingTree) {
            <app-sourcing-wallet-tree
              [sourceWallet]="sourceWallet"
              [sourcingWallets]="sourcingWallets"
              [destinationWallet]="destinationWalletForTree"
            >
            </app-sourcing-wallet-tree>
          } @else {
            <div class="sourcing-empty">No sourcing wallets available for this routing.</div>
          }
        </div>
      }
    </div>
  }

  @if (viewState === 'success') {
    <div class="summary-layout" [class.with-tree]="showsSourcingTree && hasSourcingTree">
      <div class="summary-layout-main">
        <app-success-view
          [displayDetails]="displayDetails"
          [isSettlementApp]="isSettlementApp"
          [title]="transactionError ? 'Request Failed' : 'Send Successfully'"
          [showTransactionId]="!!transactionId"
          [error]="transactionError"
          [transactionId]="transactionId"
          (actionClicked)="resetToInitialState()"
        >
        </app-success-view>
      </div>

      @if (showsSourcingTree && hasSourcingTree) {
        <div class="summary-layout-tree">
          <app-sourcing-wallet-tree
            [title]="'Confirmed Sourcing Tree'"
            [description]="'Confirmed sourcing wallets that fed the selected source wallet.'"
            [sourceWallet]="sourceWallet"
            [sourcingWallets]="sourcingWallets"
            [destinationWallet]="destinationWalletForTree"
          >
          </app-sourcing-wallet-tree>
        </div>
      }
    </div>
  }
</div>
